import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const GET_COUPON_CODE_DETAILS_REQUEST = "GET_COUPON_CODE_DETAILS_REQUEST";
export const GET_COUPON_CODE_DETAILS_SUCCESS = "GET_COUPON_CODE_DETAILS_SUCCESS";
export const GET_COUPON_CODE_DETAILS_FAILURE = "GET_COUPON_CODE_DETAILS_FAILURE";

export const GET_COUPON_CODE_LIST_REQUEST = "GET_COUPON_CODE_LIST_REQUEST";
export const GET_COUPON_CODE_LIST_SUCCESS = "GET_COUPON_CODE_LIST_SUCCESS";
export const GET_COUPON_CODE_LIST_FAILURE = "GET_COUPON_CODE_LIST_FAILURE";

export const CREATE_COUPON_CODE_REQUEST = "CREATE_COUPON_CODE_REQUEST";
export const CREATE_COUPON_CODE_SUCCESS = "CREATE_COUPON_CODE_SUCCESS";
export const CREATE_COUPON_CODE_FAILURE = "CREATE_COUPON_CODE_FAILURE";

export const UPDATE_COUPON_CODE_REQUEST = "UPDATE_COUPON_CODE_REQUEST";
export const UPDATE_COUPON_CODE_SUCCESS = "UPDATE_COUPON_CODE_SUCCESS";
export const UPDATE_COUPON_CODE_FAILURE = "UPDATE_COUPON_CODE_FAILURE";

export const DELETE_COUPON_CODE_REQUEST = "DELETE_COUPON_CODE_REQUEST";
export const DELETE_COUPON_CODE_SUCCESS = "DELETE_COUPON_CODE_SUCCESS";
export const DELETE_COUPON_CODE_FAILURE = "DELETE_COUPON_CODE_FAILURE";

export const getCouponCodes = (searchQuery) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_COUPON_CODE_LIST_REQUEST });
      const url = `${BASE_URL}/promocode/get/list/v1?searchQuery=${searchQuery && searchQuery !== undefined ? searchQuery : ''}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: GET_COUPON_CODE_LIST_SUCCESS, payload: response.data });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_COUPON_CODE_LIST_FAILURE, payload: error.message });
    }
  };
};

export const getCouponCodeDetails = (couponCodeId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_COUPON_CODE_DETAILS_REQUEST });
      const url = `${BASE_URL}/promocode/get/details/${couponCodeId}/v1`;
      const response = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: GET_COUPON_CODE_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_COUPON_CODE_DETAILS_FAILURE, payload: error.message });
    }
  };
};

export const createCouponCode = (data, navigate) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CREATE_COUPON_CODE_REQUEST });
      const url = `${BASE_URL}/promocode/create/v1`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: CREATE_COUPON_CODE_SUCCESS, payload: response.data });
      toast.success("Coupon Code Created Successfully");
      navigate("/coupon-code/list");
    } catch (error) {
      console.error(error);
      dispatch({ type: CREATE_COUPON_CODE_FAILURE, payload: error.message });
      toast.error(error.response?.data?.message || "Failed to create coupon code");
    }
  };
};

export const updateCouponCode = (couponCodeId, data, navigate) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_COUPON_CODE_REQUEST });
      const url = `${BASE_URL}/promocode/update/${couponCodeId}/v1`;
      const response = await axios.put(url, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: UPDATE_COUPON_CODE_SUCCESS, payload: response.data });
      toast.success(response.data.message);
      navigate("/coupon-code/list");
    } catch (error) {
      console.error(error);
      dispatch({ type: UPDATE_COUPON_CODE_FAILURE, payload: error.message });
      toast.error(error.response?.data?.message || "Failed to update coupon code");
    }
  };
};

export const deleteCouponCode = (couponCodeId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "IS_COUPON_CODE_UPDATED" });
      dispatch({ type: DELETE_COUPON_CODE_REQUEST });
      const url = `${BASE_URL}/promocode/delete/${couponCodeId}/v1`;
      const response = await axios.delete(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: DELETE_COUPON_CODE_SUCCESS, payload: response.data });
      toast.success("Coupon Code Deleted Successfully");
      try {
        dispatch(getCouponCodes());
      } catch (error) {
        console.error(error);
        dispatch({ type: GET_COUPON_CODE_LIST_FAILURE, payload: error.message });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: DELETE_COUPON_CODE_FAILURE, payload: error.message });
      toast.error(error.response?.data?.message || "Failed to delete coupon code");
    }
  };
};
